<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
  >
    <path d="M7.12521 5.68369C6.62521 5.3948 6 5.75563 6 6.33309V10.6668C6 11.2443 6.62522 11.6051 7.12521 11.3162L11.2501 8.93289C11.4048 8.84355 11.5 8.67854 11.5 8.49996C11.5 8.32139 11.4048 8.15637 11.2501 8.06703L7.12521 5.68369ZM0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5ZM8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5Z" />
  </svg>
</template>
